module.exports = __webpack_public_path__ + "static/media/fold.c034ce34.png";